import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTelegramChannel = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13 1C6.376 1 1 6.376 1 13C1 19.624 6.376 25 13 25C19.624 25 25 19.624 25 13C25 6.376 19.624 1 13 1ZM18.568 9.16C18.388 11.056 17.608 15.664 17.212 17.788C17.044 18.688 16.708 18.988 16.396 19.024C15.7 19.084 15.172 18.568 14.5 18.124C13.444 17.428 12.844 16.996 11.824 16.324C10.636 15.544 11.404 15.112 12.088 14.416C12.268 14.236 15.34 11.44 15.4 11.188C15.4083 11.1498 15.4072 11.1102 15.3968 11.0726C15.3863 11.0349 15.3668 11.0004 15.34 10.972C15.268 10.912 15.172 10.936 15.088 10.948C14.98 10.972 13.3 12.088 10.024 14.296C9.544 14.62 9.112 14.788 8.728 14.776C8.296 14.764 7.48 14.536 6.868 14.332C6.112 14.092 5.524 13.96 5.572 13.54C5.596 13.324 5.896 13.108 6.46 12.88C9.964 11.356 12.292 10.348 13.456 9.868C16.792 8.476 17.476 8.236 17.932 8.236C18.028 8.236 18.256 8.26 18.4 8.38C18.52 8.476 18.556 8.608 18.568 8.704C18.556 8.776 18.58 8.992 18.568 9.16Z",
		fill: "white"
	})
});
export default SvgTelegramChannel;
